import { createSlice } from "@reduxjs/toolkit";
import { FailedcustomerTagResponse } from "../../../constants/error_messages";
import { DELETE_CUSTOMER_TAG } from "../../../constants/reducer_names";
import { deleteCustomerTag } from "../../api/customerTag";

const initialState = {
  deleteCurrentCustomer: "",
  isDelete: false,
  responseError: {
    hasError: false,
    errorMessage: "",
  },
} as any;

const deleteCustomerTagSlice = createSlice({
  name: DELETE_CUSTOMER_TAG,
  initialState,
  reducers: {
    deleteCurrentCustomerTag: (state, { payload }) => {
      state.deleteCurrentCustomer = payload;
    },
    isDeletePopup: (state, { payload }) => {
      state.isDelete = payload;
    },

    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(deleteCustomerTag.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCustomerTag.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.responseError.hasError = false;
        state.responseError.errorMessage = "";
      } else {
        state.responseError.hasError = true;
        state.responseError.errorMessage =
          payload?.message ?? FailedcustomerTagResponse;
      }

      state.isDelete = false;
    });
    builder.addCase(deleteCustomerTag.rejected, (state, { payload }: any) => {
      state.responseError.hasError = true;
      state.responseError.errorMessage =
        payload?.message ?? FailedcustomerTagResponse;
      state.isDelete = false;
    });
  },
});
export const deleteCustomerTagAction = deleteCustomerTagSlice.actions;
export default deleteCustomerTagSlice.reducer;
